import { useEffect, useState } from "react";
import { Gallery } from "../../Orders/Gallery";
import {
    Modal,
    Form,
    Row,
    Col,
    Select,
    Upload,
    message,
    Button,
    Input,
    Popconfirm,
    Descriptions,
    Table,
    Popover,
    DatePicker
} from "antd";
import {
    getFirestore,
    setDoc,
    doc,
    updateDoc,
    serverTimestamp
} from "firebase/firestore";
import { getAuth } from "firebase/auth";
import { getStorage, ref, uploadBytes, getDownloadURL } from "firebase/storage";
import { fetchData, collections,statusList, reasonsList, APP_VERSION,OrderReport,confirmStatusList } from "../../../utils";
import { checkAccess } from "../../../access";
import { logUserAction } from "../../../logs";
import { PDFDownloadLink } from "@react-pdf/renderer";
import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";

dayjs.extend(customParseFormat);
const dateFormat = "DD-MM-YYYY";

const { Option } = Select;
const { TextArea } = Input;

export const EditOrderToConfirm = ({ record, editIsOpen, setIsEditOpen, role, setOrder,refetch }) => {
    const [form] = Form.useForm();
    const querydb = getFirestore();
    const auth = getAuth();
    const [paymentMethods, setPaymentMethods] = useState();
    const [couriers, setCouriers] = useState();
    const [isOpenConfirm, setOpenConfirm] = useState(false);
    const [channels, setChannels] = useState();
    const [notCancelable, setNotCancelable] = useState(true);
    const [openPayReceipt, setOpenPayReceipt] = useState(false);
    const [openDeliveryReceipt, setOpenDeliveryReceipt] = useState(false);
    const [confirmState,setConfirmState] = useState();
    const [rescheduleDate,setRescheduleDate] = useState();

    useEffect(() => {
        fetchData(querydb, collections.payment_types, setPaymentMethods);
        fetchData(querydb, collections.couriers, setCouriers);
        fetchData(querydb, collections.sale_channels, setChannels);
    }, [querydb]);

    const productColumns = [
        {
            title: "Marca",
            dataIndex: "brand",
            key: "brand",
            render: (_, product) => <span>{product.brand.toLowerCase()}</span>
        },
        {
            title: "Categoria",
            dataIndex: "category",
            key: "category",
            render: (_, product) => <span>{product.category.toLowerCase()}</span>
        },
        {
            title: "Color",
            dataIndex: "color",
            key: "color",
            render: (_, product) => <span>{product.color.toLowerCase()}</span>
        },
        {
            title: "Modelo",
            dataIndex: "model",
            key: "model",
            render: (_, product) => <span>{product.model.toLowerCase()}</span>
        },
        {
            title: "Talla",
            dataIndex: "size",
            key: "size",
            render: (_, product) => <span>{product.size.toLowerCase()}</span>
        },
        {
            title: "Observaciones",
            dataIndex: "observation",
            key: "observation",
            editable: true,
            render: (_, product) => {
                return (
                    <span>{product.observation ? product.observation.toLowerCase() : "sin observaciones"}</span>
                );
            }
        },
    ];

    const productsTable = (products) => (
        <Table dataSource={products} columns={productColumns} scroll={{
            x: 500,
        }} />
    );

    const upload = async (file) => {
        const storage = getStorage();
        const fileRef = ref(storage, file.name);
        await uploadBytes(fileRef, file);
        const downloadUrl = await getDownloadURL(fileRef);
        file.downloadUrl = downloadUrl;
    }

    const uploadOrderImage = async (file) => {
        const storage = getStorage();
        const fileRef = ref(storage, file.name);
        await uploadBytes(fileRef, file);
        const downloadUrl = await getDownloadURL(fileRef);
        file.downloadUrl = downloadUrl;
    }

    const handleReason = (value) => {
        if (value.toUpperCase() !== "NO APLICA") {
            form.setFieldsValue({
                cancelReason: value
            });
            setNotCancelable(false);
        } else {
            setNotCancelable(true);
        }
    }

    const cancelOrder = async (record) => {
        form.setFieldsValue({
            status: "Cancelado"
        });
        message.success(`Pedido ${record.serial} cancelado`);
    }

    const handleEdit = async (values) => {
        try {
            const changes = {
                paymenttype: typeof values.paymenttype !== "undefined" ?
                    values.paymenttype.toUpperCase() : record.paymenttype,
                status: typeof values.status !== "undefined" ?
                    values.status : record.status,
                courier: typeof values.courier !== "undefined" ?
                    values.courier.toUpperCase() : record.courier,
                cancelReason: typeof values.cancelReason !== "undefined" ?
                    values.cancelReason.toUpperCase() : record.cancelReason ?
                        record.cancelReason : record.status === "CANCELADO" ? "SIN SELECCIONAR" : "NO APLICA",
                payment: typeof values.payment !== "undefined" ?
                    values.payment.toUpperCase() : record.payment ? record.payment : "POR RECAUDAR",
                channel: typeof values.channel !== "undefined" ?
                    values.channel.toUpperCase() : record.channel,
                comments: typeof values.comments !== "undefined" ?
                    values.comments.toUpperCase() : record.comments ? record.comments : "SIN OBSERVACIONES",
                payable: record.payable,
                confirmStatus: typeof values.confirmStatus !== "undefined" ? 
                    values.confirmStatus : record.confirmStatus ? record.confirmStatus : "SIN ASIGNAR",
                rescheduleDate: typeof values.rescheduleDate !== "undefined" ? 
                    `${values.rescheduleDate["$D"] < 10 ? `0${values.rescheduleDate["$D"]}` : values.rescheduleDate["$D"]}/${values.rescheduleDate["$M"] < 10 ? `0${values.rescheduleDate["$M"]}` : values.rescheduleDate["$M"]}/${values.rescheduleDate["$y"]}` : 
                    record.rescheduleDate ? record.rescheduleDate : "SIN ASIGNAR",
                customerServiceComments: typeof values.customerServiceComments !== "undefined" ?
                    values.customerServiceComments.toUpperCase() : record.customerServiceComments ? record.customerServiceComments : "SIN OBSERVACIONES",
                dateEnd: serverTimestamp()
            };

            let bills = record.fileImage;

            await setDoc(doc(querydb, collections.orders, record.key), changes, { merge: true });

            if (values.fileImage && values.fileImage.fileList.length) {


                for (let i = 0; i < values.fileImage.fileList.length; i++) {
                    bills.push(values.fileImage.fileList[i].downloadUrl);
                }

                await updateDoc(doc(querydb, collections.orders, record.key), {
                    fileImage: bills
                })

            }

            if (values.orderImage && values.orderImage.fileList.length) {


                for (let i = 0; i < values.orderImage.fileList.length; i++) {
                    bills.push(values.orderImage.fileList[i].downloadUrl);
                }

                await updateDoc(doc(querydb, collections.orders, record.key), {
                    orderImage: bills
                })

            }

            if (typeof values.payable === "number" && values.payable === 0) {
                logUserAction(querydb, auth, "PAY_ORDER", record.serial, null, null, APP_VERSION);
                message.success(`Pedido ${record.serial} registrado como pago.`);
            }

            if (record.status !== values.status) {
                logUserAction(querydb, auth, "EDIT_STATUS", record.serial, values.status, null, APP_VERSION);
            }

            logUserAction(querydb, auth, "EDIT_ORDER", record.serial, "", {
                ...changes,
                fileImage: bills
            }, APP_VERSION);

            bills = null;

            form.resetFields();
            setOrder();
            await refetch();
            message.success(`Datos actualizados`);
        } catch (error) {
            console.log(error);
        }
    }

    const handleConfirm = () => {
        setTimeout(() => {
            form.submit();
            setConfirmState();
            setRescheduleDate();
            setNotCancelable(true);
            setOpenConfirm(false);
            setIsEditOpen(false);
        }, 2000);
    }

    const closeForm = () => {
        setConfirmState();
        setRescheduleDate();
        form.resetFields();
        setNotCancelable(true);
        setOrder();
        setIsEditOpen(false);
    }

    const printReport = async () => {
        form.setFieldsValue({
            status: "Preparado"
        });
        await updateDoc(doc(querydb, collections.orders, record.key), {
            status: "Preparado",
            dateEnd: serverTimestamp()
        });
        logUserAction(querydb, auth, "EDIT_STATUS", record.serial, "Preparado", null, APP_VERSION);
        await refetch();
        message.success(`Pedido ${record.serial} marcado como preparado`);
    }

    const handleConfirmStatus = (value) => {
        setConfirmState(value);
    }

    const handleRescheduleDate = (value) => {
        setRescheduleDate(value);
    }

    const handleOpenConfirm = () => {
        if(((confirmState === confirmStatusList.rescheduled) && !rescheduleDate) && !((record && record.confirmStatus === confirmStatusList.rescheduled) && record.rescheduleDate)){
            message.error("ingresar fecha de reprogramacion o cambiar estado del confirmacion del pedido antes de guardar el formulario"); 
        }else{
            setOpenConfirm(true);
        }
    }

    const disableDate = (current) => {
        return current && dayjs(current).isBefore(dayjs().add(1,'day'), 'day');
    }

    return (
        <>
            {!record ? null : (
                <Modal
                    open={editIsOpen}
                    onCancel={closeForm}
                    title={`Editar pedido #${record.serial} ${record.customerName}`}
                    footer={null}
                >
                    <Descriptions
                        bordered
                        size="small"
                    >
                        <Descriptions.Item label="Pendiente por pagar" span={4}>
                            {`$${record.payable.toFixed(2)}`}
                        </Descriptions.Item>
                        <Descriptions.Item label="Provincia" span={4}>
                            {record.province}
                        </Descriptions.Item>
                        <Descriptions.Item label="Distrito" span={4}>
                            {record.district}
                        </Descriptions.Item>
                        <Descriptions.Item label="Direccion" span={4}>
                            {record.address}
                        </Descriptions.Item>
                        <Descriptions.Item label="Telefono" span={4}>
                            {record.phoneNumber}
                        </Descriptions.Item>
                        <Descriptions.Item label="Datos de entrega" span={4}>
                            {record.remarks || "NO APLICA"}
                        </Descriptions.Item>
                        <Descriptions.Item label="Dni" span={4}>
                            {record.dni || "NO APLICA"}
                        </Descriptions.Item>
                        <Descriptions.Item label="Canal de venta" span={4}>
                            {record.salesclosingchannel}
                        </Descriptions.Item>
                        <Descriptions.Item label="Contacto Adicional" span={4}>
                            {record.aditionalContactName || "NO APLICA"}
                        </Descriptions.Item>
                        <Descriptions.Item label="Relacion" span={4}>
                            {record.aditionalContactRelation || "NO APLICA"}
                        </Descriptions.Item>
                        <Descriptions.Item label="Telefono" span={4}>
                            {record.aditionalContactPhone || "NO APLICA"}
                        </Descriptions.Item>
                        <Descriptions.Item label="Productos" span={4}>
                            <Popover
                                content={productsTable(record.products)}
                                title="Lista de productos"
                                trigger="click"
                            >
                                <Button type="link">Ver Productos</Button>
                            </Popover>
                        </Descriptions.Item>
                        <Descriptions.Item label="Reporte">
                            <Button disabled={!checkAccess("customerServiceWrite", role)} onClick={() => printReport()} type="link">
                                <PDFDownloadLink document={<OrderReport orderData={record} />} fileName={`pedido_${record.serial}.pdf`}>
                                    {({ loading, url, error, blob }) => {
                                        return "Imprimir";
                                    }}
                                </PDFDownloadLink>
                            </Button>
                        </Descriptions.Item>
                    </Descriptions>
                    <br />
                    <Form
                        form={form}
                        layout="vertical"
                        autoComplete="off"
                        onFinish={handleEdit}
                    >
                        <Row gutter={16}>
                            <Col xs={24} sm={24} md={24} lg={12}>
                                <Form.Item
                                    name="paymenttype"
                                    label="Metodo de pago"
                                //initialValue={record.paymenttype}
                                >
                                    <Select defaultValue={record.paymenttype} disabled={!checkAccess("customerServiceWrite", role) || record.payable <= 0 || record.paymenttype !== "CONTRAENTREGA"}>
                                        {paymentMethods && paymentMethods.length ?
                                            paymentMethods.map((method, i) => (
                                                <Option key={i} value={method.name}>
                                                    {method.name}
                                                </Option>
                                            )) : null
                                        }
                                    </Select>
                                    <br />
                                    {record.fileImage && record.fileImage.length ?
                                        <>
                                            <br />
                                            <Button onClick={() => setOpenPayReceipt(true)}>ver comprobantes de pago</Button>
                                        </>
                                        : null}
                                    <br />
                                    {record.orderImage && record.orderImage.length ?
                                        <>
                                            <br />
                                            <Button onClick={() => setOpenDeliveryReceipt(true)}>ver comprobantes de entrega</Button>
                                        </>
                                        : null}
                                </Form.Item>
                                <Form.Item
                                    name="channel"
                                    label="Canal"
                                //initialValue={record.channel}
                                >
                                    <Select defaultValue={record.channel} disabled={!checkAccess("customerServiceWrite", role)}>
                                        {channels && channels.length ? channels.map((channel, i) => (
                                            <Option key={i} value={channel.name}>{channel.name}</Option>
                                        )) : null}
                                    </Select>
                                </Form.Item>
                            </Col>
                            <Col xs={24} sm={24} md={24} lg={12}>
                                <Form.Item
                                    name="customerServiceComments"
                                    label="Observaciones"
                                //initialValue={record.comments ? record.comments : undefined}
                                >
                                    <TextArea defaultValue={record.customerServiceComments ? record.customerServiceComments : undefined} disabled={!checkAccess("editOrders", role)} rows={5} />
                                </Form.Item>
                            </Col>
                        </Row>
                        <Row gutter={16}>
                            <Col xs={24} sm={24} md={24} lg={12}>
                                <Form.Item
                                    label="Subir comprobantes"
                                    name="fileImage"
                                >
                                    <Upload
                                        accept=".png,.jpg,.jpeg"
                                        onChange={(info) => {
                                            if (info.file.status !== "uploading") {
                                                //console.log(info.file,info.fileList);
                                            }
                                            if (info.file.status === "done") {
                                                message.success(`${info.file.name} fue subido exitosamente.`);
                                            } else if (info.file.status === "error") {
                                                message.error(`${info.file.name} no pudo subirse.`);
                                            }
                                        }}
                                        customRequest={async ({ file, onSuccess }) => {
                                            await upload(file);
                                            onSuccess({ status: "done" });
                                        }}
                                        downloadUrl={true}
                                        disabled={!checkAccess("customerServiceWrite", role)}
                                    >
                                        <Button disabled={!checkAccess("customerServiceWrite", role)}>Cargar Archivo</Button>
                                    </Upload>
                                </Form.Item>
                                <Form.Item
                                    label="Subir foto del pedido"
                                    name="orderImage"
                                >
                                    <Upload
                                        accept=".png,.jpg,.jpeg"
                                        onChange={(info) => {
                                            if (info.file.status !== "uploading") {
                                                //console.log(info.file,info.fileList);
                                            }
                                            if (info.file.status === "done") {
                                                message.success(`${info.file.name} fue subido exitosamente.`);
                                            } else if (info.file.status === "error") {
                                                message.error(`${info.file.name} no pudo subirse.`);
                                            }
                                        }}
                                        customRequest={async ({ file, onSuccess }) => {
                                            await uploadOrderImage(file);
                                            onSuccess({ status: "done" });
                                        }}
                                        downloadUrl={true}
                                        disabled={!checkAccess("customerServiceWrite", role)}
                                    >
                                        <Button disabled={!checkAccess("customerServiceWrite", role)}>Cargar Archivo</Button>
                                    </Upload>
                                </Form.Item>
                                <Form.Item
                                    name="payment"
                                    label="Estado de pago"
                                //initialValue={record.payment}
                                >
                                    <Select defaultValue={record.payment} disabled={!checkAccess("customerServiceWrite", role)}>
                                        <Option value="POR RECAUDAR">Por Recaudar</Option>
                                        <Option value="RECAUDADO">Recaudado</Option>
                                        <Option value="PERDIDA">Perdida</Option>
                                    </Select>
                                </Form.Item>

                            </Col>
                            <Col xs={24} sm={24} md={24} lg={12}>
                                <Form.Item
                                    name="courier"
                                    label="Empresa repartidora"
                                //initialValue={record.courier}
                                >
                                    <Select defaultValue={record.courier} disabled={!checkAccess("customerServiceWrite", role)}>
                                        {couriers && couriers.length ?
                                            couriers.map((courier, i) => (
                                                <Option key={i} value={courier.name}>
                                                    {courier.name}
                                                </Option>
                                            )) : null
                                        }
                                    </Select>
                                </Form.Item>
                                <Form.Item
                                    name="status"
                                    label="Status"
                                //initialValue={record.status}
                                >
                                    <Select defaultValue={record.status} disabled={!checkAccess("customerServiceWrite", role)}>
                                        {Object.keys(statusList).filter(status => status !== "Cancelado").map((status, i) => (
                                            <Option key={i} value={status}>
                                                {status}
                                            </Option>
                                        ))}
                                    </Select>
                                </Form.Item>
                                <Form.Item
                                    name="confirmStatus"
                                    label="Estado confirmacion"
                                >
                                    <Select defaultValue={record.confirmStatus || "SIN ASIGNAR"} disabled={!checkAccess("customerServiceWrite", role)} onSelect={handleConfirmStatus}>
                                        {Object.values(confirmStatusList).map((status, i) => (
                                            <Option key={i} value={status}>
                                                {status}
                                            </Option>
                                        ))}
                                    </Select>
                                </Form.Item>
                            </Col>
                        </Row>
                        <Row gutter={16}>
                            <Col xs={24} sm={24} md={24} lg={12}>
                                <Form.Item
                                    name="cancelReason"
                                    label="Motivo de cancelacion"
                                //initialValue={record.cancelReason || reasonsList.unknown}
                                >
                                    <Select
                                        onSelect={handleReason}
                                        disabled={!checkAccess("editOrders", role)}
                                        defaultValue={record.cancelReason || reasonsList.unknown}
                                    >
                                        {Object.values(reasonsList).map((reason, i) => (
                                            <Option value={reason} key={i}>{reason}</Option>
                                        ))}
                                    </Select>
                                </Form.Item>
                                <>
                                    <Button disabled={!checkAccess("customerServiceWrite", role) || notCancelable} onClick={() => cancelOrder(record)}>Confirmar Cancelacion</Button>
                                </>
                                <br /><br />
                            </Col>
                            {(confirmState && (confirmState === confirmStatusList.rescheduled)) || (record && (record.confirmStatus === confirmStatusList.rescheduled)) ? <Col xs={24} sm={24} md={24} lg={12}>
                                <Form.Item
                                    name="rescheduleDate"
                                    label="Fecha reprogramacion"
                                >
                                    <DatePicker format={dateFormat} disabledDate={disableDate} onSelect={handleRescheduleDate}/>
                                </Form.Item>
                                {record && record.rescheduleDate ? <span>fecha reprogramacion actual : {record.rescheduleDate}</span> : rescheduleDate ? null : <span style={{"color":"#FF0000"}}>fecha reprogramacion sin asignar</span> }
                            </Col> : null}
                        </Row>
                        <Row>
                            <Button onClick={closeForm} className="btnCancel">Cancelar</Button>
                            <Form.Item>
                                <Popconfirm
                                    title="Modificar y guardar pedido?"
                                    okText="Si"
                                    cancelText="No"
                                    open={isOpenConfirm}
                                    onConfirm={handleConfirm}
                                    onCancel={() => setOpenConfirm(false)}
                                >
                                    <Button type="primary" disabled={!checkAccess("customerServiceWrite", role)} onClick={handleOpenConfirm} className="btnOK button-right">Guardar</Button>
                                </Popconfirm>
                            </Form.Item>
                        </Row>
                    </Form>
                    {record.fileImage && record.fileImage.length ?
                        <Gallery
                            images={record.fileImage}
                            isModalOpen={openPayReceipt}
                            setIsModalOpen={setOpenPayReceipt}
                        /> : null}
                    {record.orderImage && record.orderImage.length ?
                        <Gallery
                            images={record.orderImage}
                            isModalOpen={openDeliveryReceipt}
                            setIsModalOpen={setOpenDeliveryReceipt}
                        /> : null}
                </Modal>
            )}
        </>
    );
}